import styled from 'styled-components';
import { media } from './utils';

const Container = styled.div`
  margin: 0 auto 0;
  position: absolute;
  top: calc(50rem / 16);
  bottom: 0;
  ${media.minWidth(1200)`
    top: calc(80rem / 16);
  `}
  width: 100%;
  text-align: left;
  box-sizing: border-box;
  > {
    &:first-child {
      width: 100%;
    }
  }
  .full-height {
    min-height: calc(100% - 13.875rem);
    margin: 0 auto;
  }
`;

export default Container;



// WEBPACK FOOTER //
// ./src/modules/common/components/ui/Container.js